module.exports = __webpack_public_path__ + "img/InjectionCartSafe.9d39b594.jpeg";